//GENERAL ROUTES

const allLevels = ["company", "branch", "region", "group", "dealer"];

const maintenance = {
  route: "Maintenance ",
  path: "/maintenance",
  routeIcon: "wrench-screwdriver.svg",
  activeRouteIcon: "wrench-screwdriver-active.svg",
  children: [],
  name: ["maintenance"],
  view: ["maintenance"],
  levels: allLevels,
  roles: ["Maintenance", "ManageMaintenance", "ViewMaintenance"],
};

const vendorMgt = {
  route: "Vendor management",
  path: "/vendor-mgt",
  routeIcon: "grey-personalcard.svg",
  activeRouteIcon: "green-personalcard.svg",
  children: [],
  name: ["vendor-details", "vendor-mgt"],
  view: ["maintenance"],
  levels: allLevels,
  roles: ["viewVendor", "manageVendor"],
};

const expenseMgt = {
  route: "Expense Management",
  path: "/Expense-management",
  routeIcon: "money-4.svg",
  activeRouteIcon: "money-4-green.svg",
  children: [],
  name: ["Expense Management", "Expense Details", "Expense Category"],
  view: ["station"],
  levels: allLevels,
  roles: ["ViewExpense", "ManageExpense"],
};

const POS = {
  route: "POS",
  path: "/remis/pos",
  routeIcon: "card-pos.svg",
  activeRouteIcon: "green-card-pos.svg",
  children: [],
  name: ["remis-pos", "remis-pos-transaction"],
  view: ["remis"],
  levels: allLevels,
  roles: ["ManageRemis", "POS"],
};

const bank = {
  route: "Bank",
  path: "/bank-accounts",
  routeIcon: "bank.svg",
  activeRouteIcon: "bank-green.svg",
  children: [
    {
      route: "Bank accounts",
      path: "/bank-accounts",
    },
    {
      route: "Bank account requests",
      path: "/bank-account-requests",
    },
  ],
  view: ["station"],
  name: ["bank-accounts"],
  levels: allLevels,
  roles: ["manageBankAccounts"],
};

// const rentalRecords = {
//   route: "Rental Mgt",
//   path: "",
//   routeIcon: "building-office-2.svg",
//   activeRouteIcon: "active-building-office-2.svg",
//   children: [
//     {
//       route: "Properties",
//       path: "/properties",
//       roles: ["ManageRent", "RentProperties"],
//     },
//     {
//       route: "Rent records",
//       path: "/rent-records",
//       roles: ["ManageRent", "RentRecords"],
//     },
//     {
//       route: "Occupants",
//       path: "/occupants",
//       roles: ["ManageRent", "Occupants"],
//     },
//   ],
//   name: [
//     "rent-records",
//     "properties",
//     "property-details",
//     "Occupants",
//     "occupant-details",
//   ],
//   view: ["stationLease"],
//   levels: allLevels,
//   // roles: ["ViewRent", "ManageRent"],
//   roles: ["ManageRent", "RentProperties", "RentRecords", "Occupants"],
// };

const properties = {
  route: "Properties",
  path: "/properties",
  routeIcon: "building-office-2.svg",
  activeRouteIcon: "active-building-office-2.svg",
  children: [],
  name: ["properties", "property-details"],
  view: ["stationLease"],
  levels: allLevels,
  roles: ["ManageRent", "RentProperties"],
};

const dueProperties = {
  route: "Due Payment",
  path: "/due-properties",
  routeIcon: "money-forbidden(inactive).svg",
  activeRouteIcon: "money-forbidden.svg",
  children: [],
  name: ["due-properties"],
  view: ["stationLease"],
  levels: allLevels,
  roles: ["ManageRent", "RentProperties"],
};

const rentalRecords = {
  route: "Rent records",
  path: "/rent-records",
  routeIcon: "receipt-text.svg",
  activeRouteIcon: "receipt-text-active.svg",
  children: [],
  name: ["rent-records"],
  view: ["stationLease"],
  levels: allLevels,
  roles: ["ManageRent", "RentProperties", "RentRecords"],
};

const occupants = {
  route: "Occupants",
  path: "/occupants",
  routeIcon: "user-group.svg",
  activeRouteIcon: "inactive-user-group.svg",
  children: [],
  name: ["Occupants", "occupant-details"],
  view: ["stationLease"],
  levels: allLevels,
  roles: ["ManageRent", "Occupants"],
};

const support = {
  route: "Support",
  path: "/support",
  routeIcon: "message-question.svg",
  activeRouteIcon: "active-message-question.svg",
  children: [],
  name: ["support"],
  levels: allLevels,
  view: ["maintenance"],
};

const userMgt = {
  route: "User management",
  path: "/user-management",
  routeIcon: "user-group.svg",
  activeRouteIcon: "inactive-user-group.svg",
  children: [],
  name: ["user-management", "single-user"],
  view: ["station"],
  levels: allLevels,
  roles: ["ManageUsers"],
};
const manageApproval = {
  route: "Manage approval",
  path: "/manage-approval",
  routeIcon: "grey-check-badge.svg",
  activeRouteIcon: "active-check-badge.svg",
  children: [],
  name: ["manage-approval"],
  view: ["station"],
  levels: allLevels,
  roles: ["manageApproval"],
};

export const generalRoutes = [
  manageApproval,
  bank,
  maintenance,
  vendorMgt,
  userMgt,
  expenseMgt,
  POS,

  // 🚨 PROPERTIES
  properties,
  dueProperties,
  rentalRecords,
  occupants,

  support,
];
